import { Heading, Label, VerticalSpace } from '@elhub/ds-components'

import React from 'react'
import { useTranslation } from 'react-i18next'

import { ChangelogMessages } from '../../locales/messages/changelog'

const EnergyData = () => {
  const { t } = useTranslation()

  return (
    <>
      <Heading level='2' spacing>
        {t(ChangelogMessages.CHANGEDATE20 as any)}
      </Heading>
      <Label>{t(ChangelogMessages.NEW as any)}</Label>
      <ul>
        <li>{t(ChangelogMessages.CHANGEDATE20_INFO1 as any)}</li>
      </ul>
      <VerticalSpace size='3' />
      <Heading level='2' spacing>
        {t(ChangelogMessages.CHANGEDATE19 as any)}
      </Heading>
      <Label>{t(ChangelogMessages.NEW as any)}</Label>
      <ul>
        <li>{t(ChangelogMessages.CHANGEDATE19_INFO1 as any)}</li>
      </ul>
      <VerticalSpace size='3' />
      <Heading level='2' spacing>
        {t(ChangelogMessages.CHANGEDATE18 as any)}
      </Heading>
      <Label>{t(ChangelogMessages.NEW as any)}</Label>
      <ul>
        <li>{t(ChangelogMessages.CHANGEDATE18_INFO1 as any)}</li>
        <li>{t(ChangelogMessages.CHANGEDATE18_INFO2 as any)}</li>
      </ul>
      <VerticalSpace size='3' />
      <Heading level='2' spacing>
        {t(ChangelogMessages.CHANGEDATE17 as any)}
      </Heading>
      <Label>{t(ChangelogMessages.NEW as any)}</Label>
      <ul>
        <li>{t(ChangelogMessages.CHANGEDATE17_INFO1 as any)}</li>
      </ul>
      <VerticalSpace size='3' />
      <Heading level='2' spacing>
        {t(ChangelogMessages.CHANGEDATE16 as any)}
      </Heading>
      <Label>{t(ChangelogMessages.NEW as any)}</Label>
      <ul>
        <li>{t(ChangelogMessages.CHANGEDATE16_INFO1 as any)}</li>
      </ul>
      <VerticalSpace size='3' />
      <Heading level='2' spacing>
        {t(ChangelogMessages.CHANGEDATE15 as any)}
      </Heading>
      <Label>{t(ChangelogMessages.NEW as any)}</Label>
      <ul>
        <li>{t(ChangelogMessages.CHANGEDATE15_INFO1 as any)}</li>
      </ul>
      <VerticalSpace size='3' />
      <Heading level='2' spacing>
        {t(ChangelogMessages.CHANGEDATE14 as any)}
      </Heading>
      <Label>{t(ChangelogMessages.NEW as any)}</Label>
      <ul>
        <li>{t(ChangelogMessages.CHANGEDATE14_INFO1 as any)}</li>
      </ul>
      <VerticalSpace size='3' />
      <Heading level='2' spacing>
        {t(ChangelogMessages.CHANGEDATE13 as any)}
      </Heading>
      <Label>{t(ChangelogMessages.NEW as any)}</Label>
      <ul>
        <li>{t(ChangelogMessages.CHANGEDATE13_INFO1 as any)}</li>
        <li>{t(ChangelogMessages.CHANGEDATE13_INFO2 as any)}</li>
        <li>{t(ChangelogMessages.CHANGEDATE13_INFO3 as any)}</li>
        <li>{t(ChangelogMessages.CHANGEDATE13_INFO4 as any)}</li>
        <li>{t(ChangelogMessages.CHANGEDATE13_INFO5 as any)}</li>
        <li>{t(ChangelogMessages.CHANGEDATE13_INFO6 as any)}</li>
        <li>{t(ChangelogMessages.CHANGEDATE13_INFO7 as any)}</li>
        <li>{t(ChangelogMessages.CHANGEDATE13_INFO8 as any)}</li>
        <li>{t(ChangelogMessages.CHANGEDATE13_INFO9 as any)}</li>
        <li>{t(ChangelogMessages.CHANGEDATE13_INFO10 as any)}</li>
        <li>{t(ChangelogMessages.CHANGEDATE13_INFO11 as any)}</li>
        <li>{t(ChangelogMessages.CHANGEDATE13_INFO12 as any)}</li>
      </ul>
      <VerticalSpace size='3' />
      <Heading level='2' spacing>
        {t(ChangelogMessages.CHANGEDATE12 as any)}
      </Heading>
      <Label>{t(ChangelogMessages.NEW as any)}</Label>
      <ul>
        <li>{t(ChangelogMessages.CHANGEDATE12_INFO1 as any)}</li>
        <li>{t(ChangelogMessages.CHANGEDATE12_INFO2 as any)}</li>
        <li>{t(ChangelogMessages.CHANGEDATE12_INFO3 as any)}</li>
      </ul>
      <VerticalSpace />
      <Label>{t(ChangelogMessages.UPDATES as any)}</Label>
      <ul>
        <li>{t(ChangelogMessages.CHANGEDATE12_INFO4 as any)}</li>
        <li>{t(ChangelogMessages.CHANGEDATE12_INFO5 as any)}</li>
      </ul>
      <VerticalSpace size='3' />
      <Heading level='2' spacing>
        {t(ChangelogMessages.CHANGEDATE11 as any)}
      </Heading>
      <Label>{t(ChangelogMessages.NEW as any)}</Label>
      <ul>
        <li>{t(ChangelogMessages.CHANGEDATE11_INFO1 as any)}</li>
      </ul>
      <VerticalSpace size='3' />
      <Heading level='2' spacing>
        {t(ChangelogMessages.CHANGEDATE10 as any)}
      </Heading>
      <Label>{t(ChangelogMessages.NEW as any)}</Label>
      <ul>
        <li>{t(ChangelogMessages.CHANGEDATE10_INFO1 as any)}</li>
        <li>{t(ChangelogMessages.CHANGEDATE10_INFO2 as any)}</li>
        <li>{t(ChangelogMessages.CHANGEDATE10_INFO3 as any)}</li>
      </ul>
      <VerticalSpace size='3' />
      <Heading level='2' spacing>
        {t(ChangelogMessages.CHANGEDATE9 as any)}
      </Heading>
      <Label>{t(ChangelogMessages.NEW as any)}</Label>
      <ul>
        <li>{t(ChangelogMessages.CHANGEDATE9_INFO1 as any)}</li>
      </ul>
      <VerticalSpace size='3' />
      <Heading level='2' spacing>
        {t(ChangelogMessages.CHANGEDATE8 as any)}
      </Heading>
      <Label>{t(ChangelogMessages.NEW as any)}</Label>
      <ul>
        <li>{t(ChangelogMessages.CHANGEDATE8_INFO1 as any)}</li>
      </ul>
      <VerticalSpace />
      <Label>{t(ChangelogMessages.UPDATES as any)}</Label>
      <ul>
        <li>{t(ChangelogMessages.CHANGEDATE8_INFO2 as any)}</li>
      </ul>
      <VerticalSpace size='3' />
      <Heading level='2' spacing>
        {t(ChangelogMessages.CHANGEDATE7 as any)}
      </Heading>
      <Label>{t(ChangelogMessages.NEW as any)}</Label>
      <ul>
        <li>{t(ChangelogMessages.CHANGEDATE7_INFO1 as any)}</li>
      </ul>
      <VerticalSpace />
      <Label>{t(ChangelogMessages.UPDATES as any)}</Label>
      <ul>
        <li>{t(ChangelogMessages.CHANGEDATE7_INFO2 as any)}</li>
      </ul>
      <VerticalSpace size='3' />
      <Heading level='2' spacing>
        {t(ChangelogMessages.CHANGEDATE6 as any)}
      </Heading>
      <Label>{t(ChangelogMessages.NEW as any)}</Label>
      <ul>
        <li>{t(ChangelogMessages.CHANGEDATE6_INFO1 as any)}</li>
        <li>{t(ChangelogMessages.CHANGEDATE6_INFO2 as any)}</li>
      </ul>
      <VerticalSpace size='3' />
      <Heading level='2' spacing>
        {t(ChangelogMessages.CHANGEDATE5 as any)}
      </Heading>
      <Label>{t(ChangelogMessages.NEW as any)}</Label>
      <ul>
        <li>{t(ChangelogMessages.CHANGEDATE5_INFO1 as any)}</li>
        <li>{t(ChangelogMessages.CHANGEDATE5_INFO2 as any)}</li>
      </ul>
      <VerticalSpace size='3' />
      <Heading level='2' spacing>
        {t(ChangelogMessages.CHANGEDATE4 as any)}
      </Heading>
      <Label>{t(ChangelogMessages.NEW as any)}</Label>
      <ul>
        <li>{t(ChangelogMessages.CHANGEDATE4_INFO1 as any)}</li>
      </ul>
      <VerticalSpace />
      <Label>{t(ChangelogMessages.UPDATES as any)}</Label>
      <ul>
        <li>{t(ChangelogMessages.CHANGEDATE4_INFO2 as any)}</li>
      </ul>
      <VerticalSpace size='3' />
      <Heading level='2' spacing>
        {t(ChangelogMessages.CHANGEDATE3 as any)}
      </Heading>
      <Label>{t(ChangelogMessages.NEW as any)}</Label>
      <ul>
        <li>{t(ChangelogMessages.CHANGEDATE3_INFO1 as any)}</li>
      </ul>
      <VerticalSpace size='3' />
      <Heading level='2' spacing>
        {t(ChangelogMessages.CHANGEDATE2 as any)}
      </Heading>
      <Label>{t(ChangelogMessages.UPDATES as any)}</Label>
      <ul>
        <li>{t(ChangelogMessages.CHANGEDATE2_INFO1 as any)}</li>
      </ul>
      <VerticalSpace size='3' />
      <Heading level='2' spacing>
        {t(ChangelogMessages.CHANGEDATE1 as any)}
      </Heading>
      <Label>{t(ChangelogMessages.NEW as any)}</Label>
      <ul>
        <li>{t(ChangelogMessages.CHANGEDATE1_INFO1 as any)}</li>
        <li>{t(ChangelogMessages.CHANGEDATE1_INFO2 as any)}</li>
      </ul>
    </>
  )
}

export default EnergyData
